<template>
    <div >
        <el-carousel :interval="5000" indicator-position="none" :height="screenheight">
            <el-carousel-item v-for="(item, index) in dkyj_lbtp" :key="index">
                <img :src="item.format_img" style="width: 100%; height: 100%;" alt="">
            </el-carousel-item>
        </el-carousel>

        <div style="width: 1200px; margin: 100px auto;">
            <div class="ffgssasa mt50 ">
                <div class="pr shouxing" style="width: 200px; height: 300px;" v-for="(item, index) in data_list" :key="index" @click="toinfo(item.id )">
                    <img style="width: 200px; height: 300px;" :src="item.format_img" alt="">
                    <div class="pa flx fdc jcc" style="width: 170px; height: 110px; background-color: rgba(125,125,125,0.5); bottom: 50px; padding: 0 15px;">
                        <div class="clf tc fs14">{{item.name}}</div>
                        <span class="clf dv3 mt5 dddddff" style="font-size: 12px; line-height: 20px; letter-spacing: 1px" v-html="item.image_content"></span>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

export default {
    name: 'Bigshotlist',    
    data () {
        return {
            screenheight: '500px',
            dkyj_lbtp: '',
            data_list: '',
            screenWidth: null
        }
    },
    methods:{
        getData2() {
            this.$post('index.php?s=/api/index/dkyj_jh', {
                wxapp_id: 10001
            })
            .then((res) => {
                if(res.code == 1) {
                    this.dkyj_lbtp = res.data.dkyj_lbtp;
                    this.data_list = res.data.list;
                    var a_data = res.data.list;
                    for (let i = 0; i < a_data.length; i++) {
                        if(a_data[i].image_content) {
                            a_data[i].image_content = this.showHtml(a_data[i].image_content);
                            a_data[i].image_content = a_data[i].image_content.replace(/<\/?br[^>]*>/gi,'')
                        }
                    }
                    this.data_list = a_data;
                }
            }) 
        },
        showHtml(str){
            return str
            .replace(str ? /&(?!#?\w+;)/g : /&/g, '&amp;')
            .replace(/&lt;/g,"<")
            .replace(/&gt;/g,">")
            .replace(/&quot;/g,"\"")
            .replace(/&#39;/g, "\'")
            .replace(/<\/?p[^>]*>/gi,'')
            .replace(/<\/?hr[^>]*>/gi,'')
            .replace(/<\/?img[^>]*>/gi,'')
            .replace(/&amp;nbsp;/g,'\u3000')
        },
        toinfo(id) {
            this.$router.push({
                path: '/bigshotinfo',
                query: {
                    id: id
                }
            })
        },
    },
    watch: {
        screenWidth: {
            handler: function (val, oldVal) {
                if (val*500/1920 < 321.5) {
                    this.screenheight = '321.5px';
                } else {
                    this.screenheight = val*500/1920 + 'px';
                }
            },
        },
    },
    created() {
        var data = this.$route.query;
        this.id = data.id;
        this.getData2();
        document.title = '专家委员会';
    },
    mounted() {
        this.screenWidth = document.body.clientWidth;
        window.onresize = () => {
            return (() => {
                this.screenWidth = document.body.clientWidth;
            })()
        }
	},
}
</script>

<style scoped>
    .ffgssasa{
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        grid-column-gap: 50px; 
        grid-row-gap: 50px;
    }
</style>


// WEBPACK FOOTER //
// src/components/bigshot/bigshotlist.vue